<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Batch E-Coupons Upload</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            v-if="!isUpload"
            @click="toggleIsUpload"
            class="btn btn-link btn-upload"
          >
            <i class="fa fa-upload"></i> Upload Data
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Upload Section -->
    <div class="section mb-4" v-if="isUpload">
      <form @submit.prevent="upload">
        <div class="row">
          <!--<div class="col-12">
            <input id="hasIssueCodes" type="checkbox" v-model="hasIssueCodes" />
            <label for="hasIssueCodes">Allow Issued Date</label>
          </div>-->

          <div
            class="col-md-3"
            v-if="
              tokenObj.role == userRoleSuperAdmin ||
              tokenObj.role == userRoleAdmin
            "
          >
            <select class="form-control" v-model="merchantIdUpload" required>
              <option value>-- Select Merchant --</option>
              <option
                v-for="item in merchantsUpload"
                :key="item.id"
                :value="item.id"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
          <div
            class="col-md-4 mt-1"
            :class="{ 'ml-3': tokenObj.role == userRoleMerchantAdmin }"
          >
            <div style="margin-bottom: 12px">
              <input
                @change="onFileSelected($event)"
                type="file"
                accept=".xlsx"
                class="custom-file-input"
                id="excelFile"
                ref="excelFile"
                style="cursor: pointer"
                required
              />
              <label
                class="custom-file-label"
                for="excelFile"
                style="cursor: pointer"
              >
                {{ file ? file.name : "Upload file..." }}
              </label>
            </div>
            <a
              :href="templateFileUrl"
              style="margin-left: -15px; font-size: 13px"
            >
              Download Template File
            </a>
          </div>
          <div class="col-md-4" style="margin-top: 7px">
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              :disabled="!file"
            >
              <i class="fa fa-upload"></i> Upload
            </button>
            <button
              type="button"
              v-if="isUpload"
              @click="toggleIsUpload"
              class="btn btn-sm btn-danger"
            >
              <i class="fa fa-times"></i> Cancel
            </button>
          </div>
        </div>
      </form>
      <div class="row mt-3" v-if="errors && errors.length">
        <div class="col-md-8">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th colspan="8" class="text-center">Error Details</th>
              </tr>
              <tr>
                <th class="no-col">Row</th>
                <th style="width: 30%">Value</th>
                <th class="text-center">Error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(error, i) in errors" :key="i">
                <td class="no-col align-middle">{{ error.row }}</td>
                <td class="align-middle"><div v-html="error.value"></div></td>
                <td class="align-middle">
                  <div class="text-danger" v-html="error.message"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Upload Section -->

    <!-- Search Filter -->
    <div class="row">
      <div
        class="col-md-3"
        v-if="
          tokenObj.role == userRoleSuperAdmin || tokenObj.role == userRoleAdmin
        "
      >
        <div class="form-group">
          <label>Merchant</label>
          <Select2 v-model="filter.merchantId" :options="merchants" />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Code</label>
          <input type="text" class="form-control" v-model="filter.code" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Uploaded from</label>
          <input
            type="date"
            class="form-control"
            v-model="filter.uploadedFrom"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Uploaded to</label>
          <input type="date" class="form-control" v-model="filter.uploadedTo" />
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">
          Search
        </button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3" v-if="code == ''">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <div class="row mt-3" v-else>
      &nbsp;
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th v-if="code == ''" class="no-col">No</th>
                <th
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                >
                  Merchant
                </th>
                <th style="width: 200px">Uploaded Date</th>
                <th style="width: 120px;">Total <br>Uploaded</th>
                <th style="width: 120px;">Total <br>Active</th>
                <th style="width: 120px;">Total <br>Issued</th>
                <th style="width: 120px;">Total <br>Redeemed</th>
                <th style="width: 120px;">Total <br>Cancelled</th>
                <th style="width: 120px;">Total <br>Voided</th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody v-if="$store.state.isLoading">
              <tr>
                <td class="text-center" colspan="8">Loading ...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(rec, i) in records" :key="i">
                <template v-if="!code || (code && i % 2 == 0)">
                  <td v-if="code == ''" class="no-col" :rowspan="code && i % 2 == 0 ? 2 : 1">
                    {{
                      paging.CurrentPage * paging.SizePerPage -
                      paging.SizePerPage +
                      (code && i % 2 == 0 ? i / 2 : i) +
                      1
                    }}
                  </td>
                  <td
                    v-if="
                      tokenObj.role == userRoleSuperAdmin ||
                      tokenObj.role == userRoleAdmin
                    "
                  >
                    {{ rec.merchant_name }}
                  </td>
                  <td>{{ rec.uploaded_date_display }}</td>
                  <td>{{ rec.total_codes }}</td>
                  <td>{{ (rec.total_codes - rec.total_issued_codes - rec.total_redeemed_codes - rec.total_cancelled_codes - rec.total_voided_codes) }}</td>
                  <td>{{ rec.has_issue_codes == 1 ? rec.total_issued_codes : 'NA' }}</td>
                  <td>{{ rec.total_redeemed_codes }}</td>
                  <td>{{ rec.total_cancelled_codes }}</td>
                  <td>{{ rec.total_voided_codes }}</td>
                  <td class="action-col">
                    <button
                      class="btn btn-sm btn-primary"
                      @click="viewBatchEcouponDetail(rec.id)"
                    >
                      <i class="fa fa-file-alt mr-1"></i>View Codes
                    </button>
                  </td>
                </template>

                <td v-if="code && i % 2 == 1" colspan="8">
                  <table
                    class="table table-bordered custom-table mt-1"
                    style="width: 800px"
                  >
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 25%" class="code-th">Code</th>
                        <th style="width: 150px" class="code-th">Status</th>
                        <th style="width: 200px">Issued Date</th>
                        <th style="width: 200px">Redeemed Date</th>
                        <th style="width: 200px">Cancelled Date</th>
                        <th style="width: 200px">Voided Date</th>
                        <th class="code-th">Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in rec.codes" :key="rec.id + i">
                        <td>{{ item.value }}</td>
                        <td>{{ item.status }}</td>
                        <td>{{ item.issued_date_display ? item.issued_date_display : '-' }}</td>
                        <td>{{ item.redeemed_date_display ? item.redeemed_date_display : '-' }}</td>
                        <td>{{ item.cancelled_date_display ? item.cancelled_date_display : '-' }}</td>
                        <td>{{ item.voided_date_display ? item.voided_date_display : '-' }}</td>
                        <td>
                          <span v-if="item.addon_name">Package Details: {{ item.addon_name }}<br></span>
                          <span v-if="item.booking_confirmation_no">Confirmation No: {{ item.booking_confirmation_no }}<br></span>
                          <span v-if="item.booking_id">Reservation ID: {{ item.booking_id }}<br></span>
                          <span v-if="item.booking_date">{{ rec.merchant_addon_date_label }}: {{ item.booking_date }}<br></span>
                          <span v-if="item.addon_price">Unit Selling Price: {{ item.addon_price }}<br></span>
                          <span style="text-wrap: auto;" v-if="item.remarks">{{ item.remarks }}</span>
                          <span style="text-wrap: auto;" v-if="item.cancellation_reason">Cancellation Reason: {{ item.cancellation_reason }}</span>
                          <span style="text-wrap: auto;" v-if="item.void_remarks">Void Remarks: {{ item.void_remarks }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label class="mb-0">Code</label>
                        <input
                          disabled
                          type="text"
                          class="form-control form-control-sm"
                          :value="rec.code.value"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="mb-0">Remarks</label>
                        <textarea
                          disabled
                          class="form-control form-control-sm"
                          :value="rec.code.remarks"
                          style="height: 50px"
                        >
                        </textarea>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label class="mb-0">Status</label>
                        <input
                          disabled
                          type="text"
                          class="form-control form-control-sm"
                          :value="rec.code.status"
                        />
                      </div>
                    </div>
                  </div> -->
                </td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="8" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="code =='' && records && records.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          (code ? records.length / 2 : records.length)
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
  <div class="row mb-4" v-else>
    &nbsp;
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import * as XLSX from "xlsx";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      records: [],
      //upload
      file: null,
      isUpload: false,
      merchantsUpload: [],
      merchantIdUpload: "",
      hasIssueCodes: false,
      errors: [],
      //pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
      },
      totalRecords: "",
      //filter
      merchants: [],
      merchantId: "",
      code: "",
      uploadedFrom: "",
      uploadedTo: "",
      filter: {
        merchantId: "0",
        code: "",
        uploadedFrom: "",
        uploadedTo: "",
      },
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
    templateFileUrl() {
      const { protocol, host } = window.location;
      return `${protocol}//${host}/static/BatchUpload_Template.xlsx`;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getBatchEcouponList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    //file upload
    toggleIsUpload() {
      this.isUpload = !this.isUpload;
    },
    onFileSelected(e) {
      this.file = null;
      this.errors = [];
      this.file = e.target.files[0];
      if (this.file && this.file.name.split(".").pop() == "xlsx") {
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(this.file);
      }
    },
    upload() {
      //validate file extension;
      if (this.file && this.file.name.split(".").pop() != "xlsx") {
        this.$swal("Please select an xlsx file", { icon: "error" });
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to import the data?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.errors = [];
          //process
          let fileReader = new FileReader();
          fileReader.readAsArrayBuffer(this.file);
          fileReader.onload = (event) => {
            let binaryData = event.target.result;
            let workbook = XLSX.read(binaryData, { type: "binary" });
            let data = XLSX.utils.sheet_to_json(
              workbook.Sheets[workbook.SheetNames[0]],
              {
                defval: "",
                header: "A",
                blankrows: true,
              }
            );
            //validate header and blank row
            if (
              !this.validateHeader(data[0]) ||
              !this.validateBlankRecords(data)
            ) {
              this.$swal("Import failed. Please see error details", {
                icon: "error",
              });
              return;
            }
            //format data before passing to server
            let formattedData = this.format(data);
            //if no error, begin import
            if (!this.errors.length) {
              this.importData(formattedData);
            }
          };
          //clear file after upload
          this.file = null;
          this.$refs.excelFile.value = null;
        }
      });
    },
    validateHeader(header) {
      let headerTitle = header["A"];
      if (!headerTitle || (headerTitle && headerTitle != "Code")) {
        this.errors.push({
          row: "1",
          value: !headerTitle ? "" : headerTitle,
          message: "Header title must be Code",
        });
        return false;
      }
      return true;
    },
    validateBlankRecords(data) {
      let hasBlankRow = false;
      for (let i = 1; i < data.length; i++) {
        let row = data[i];
        if (!row["A"]) {
          hasBlankRow = true;
          this.errors.push({
            row: i + 1,
            value: "",
            message: "Row cannot be blank",
          });
        }
      }
      return !hasBlankRow;
    },
    format(data) {
      let formattedData = [];
      for (let i = 1; i < data.length; i++) {
        let row = data[i];
        formattedData.push({
          row: i + 1,
          code: row["A"],
        });
      }
      return formattedData;
    },
    importData(data) {
      let param = {
        merchant_id: this.merchantIdUpload,
        hasIssueCodes: this.hasIssueCodes,
        data: data,
      };
      this.$store.state.isLoading = true;
      API.importBatchEcouponData(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.$swal(response.data.message, { icon: "success" });
            this.getBatchEcouponList();
            this.merchantIdUpload = "";
            this.hasIssueCodes = false;
          } else {
            this.$swal(response.data.message, { icon: "error" });
            this.errors = response.data.errors;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //main
    getMerchants() {
      API.getAllMerchants({}, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.merchantsUpload = [...response.data.records];
            response.data.records.unshift({ id: "0", text: "All" });
            this.merchants = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    search() {
      this.merchantId = this.filter.merchantId;
      this.code = this.filter.code;
      this.uploadedFrom = this.filter.uploadedFrom;
      this.uploadedTo = this.filter.uploadedTo;
      this.getBatchEcouponList();
    },
    getBatchEcouponList() {
      let param = {
        merchant_id: this.merchantId == "0" ? "" : this.merchantId,
        code: this.code,
        uploaded_from: this.uploadedFrom,
        uploaded_to: this.uploadedTo,
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
      };
      this.$store.state.isLoading = true;
      API.getBatchEcoupons(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.records;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.page_count;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
            //format data when filter with code
            if (this.code) {
              let tempArr = [];
              for (let item of response.data.records) {
                for (let i = 1; i <= 2; i++) {
                  tempArr.push({
                    id: item.id,
                    merchant_id: item.merchant_id,
                    merchant_name: item.merchant_name,
                    merchant_addon_date_label: item.merchant_addon_date_label,
                    uploaded_date: item.uploaded_date,
                    uploaded_date_display: item.uploaded_date_display,
                    total_codes: item.total_codes,
                    total_issued_codes: item.total_issued_codes,
                    total_redeemed_codes: item.total_redeemed_codes,
                    total_cancelled_codes: item.total_cancelled_codes,
                    total_voided_codes: item.total_voided_codes,
                    has_issue_codes: item.has_issue_codes,
                    codes: item.codes,
                  });
                }
              }
              this.records = tempArr;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    viewBatchEcouponDetail(id) {
      let routerName = "adminBatchEcouponDetail";
      if (this.tokenObj.role == this.userRoleMerchantAdmin) {
        routerName = "merchantBatchEcouponDetail";
      }
      this.$router.push({ name: routerName, params: { id: id } });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getBatchEcouponList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getBatchEcouponList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getBatchEcouponList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getBatchEcouponList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getBatchEcouponList();
    },
  },
  created() {
    this.getMerchants();
    this.getBatchEcouponList();
  },
};
</script>

<style scoped>
.custom-table tr {
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
.table.custom-table > thead > tr > th.code-th {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Share/BatchEcouponList.vue